/**
 * Console interceptor to capture console logs for feedback submission
 */

const consoleLogs: string[] = [];
const MAX_CONSOLE_LOGS = 100;

// Store original console methods
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
};

let isInitialized = false;

/**
 * Initialize console interceptor
 * Should be called once at app startup
 */
export function initConsoleInterceptor(): void {
  if (isInitialized) {
    return;
  }

  // Intercept console methods
  (['log', 'warn', 'error'] as const).forEach((method) => {
    (console as any)[method] = (...args: any[]) => {
      const timestamp = new Date().toISOString();
      const logEntry = `[${timestamp}] [${method.toUpperCase()}] ${args
        .map((arg) => (typeof arg === 'object' ? JSON.stringify(arg) : String(arg)))
        .join(' ')}`;

      consoleLogs.push(logEntry);

      // Keep only last MAX_CONSOLE_LOGS entries
      if (consoleLogs.length > MAX_CONSOLE_LOGS) {
        consoleLogs.shift();
      }

      // Call original console method
      originalConsole[method](...args);
    };
  });

  isInitialized = true;
  console.log('Console interceptor initialized');
}

/**
 * Get captured console logs
 */
export function getConsoleLogs(): string[] {
  return [...consoleLogs];
}

/**
 * Clear captured console logs
 */
export function clearConsoleLogs(): void {
  consoleLogs.length = 0;
}
